/**
 * Cuts a translated sentence around one word that is shown differently
 * (bold), so the words stay whole in the translations and the page can still
 * style the part.
 *
 * Who uses it: sections/Share.tsx.
 *
 * @module splitAround
 */

/** Stands where the styled part goes while the sentence is translated; never in real text. */
const MARK = '\u0001';

/**
 * Asks for a sentence with a placeholder and cuts it where the placeholder was.
 *
 * @param translate - The translation function.
 * @param key - The sentence's key; its text holds the placeholder.
 * @param name - The placeholder's name, without braces.
 * @returns The text before and after the placeholder.
 */
export function splitAround(translate: (key: string, params?: Record<string, string | number>) => string, key: string, name: string): [string, string] {
  const [before = '', after = ''] = translate(key, { [name]: MARK }).split(MARK);
  return [before, after];
}
